import dayjs from '../../../dayjs/dayjs_timezone.js';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formatHours, convertDateFormat } from '../../utilities/timeUtility';
import { interpolatePriceToTemplate, isDefaultTitle, priceFormat } from '../../utilities/helperUtility';
import { stringToBoolean } from '../../utilities/conversionUtility';
import { rtlRegions } from '../../utilities/localizationUtility';
import Icon from '../../components/Icon';

class VariantsBlock extends Component {
  formatStatToEndTime(start, finish) {
    const { allDay, isDisableFinishDate, isHideTime, locale, settings: { region, setting }, timeZone, timeFormat } = this.props;
    const startDate = new Date(start);
    const finishDate = new Date(finish);
    const startTime = formatHours(startDate, locale, timeZone, timeFormat);
    const finishTime = formatHours(finishDate, locale, timeZone, timeFormat);
    const finishDateSelected = dayjs(finishDate).tz(timeZone).locale(region).format(convertDateFormat(region));
    const dateSelected = dayjs(startDate).tz(timeZone).locale(region).format(convertDateFormat(region));
    const dir = rtlRegions.includes(region) ? 'rtl' : '';
    const canShowTime = !allDay && !isHideTime;
    let startStr = dateSelected;
    let finishStr = finishTime;

    if (canShowTime) startStr = startStr + ' ' + startTime;

    if (!canShowTime) {
      finishStr = finishDateSelected;
    } else if (dateSelected !== finishDateSelected) {
      finishStr = finishDateSelected + ' ' + finishStr;
    }

    return (
      <>
        <span dir={dir}>{startStr}</span>
        {!isDisableFinishDate &&
          <> - <span dir={dir}>{finishStr}</span></>
        }
      </>
    )
  };

  render() {
    const {
      productTitle, variants, selectedTimeSlot, selectedCourse,
      settings: { setting, region }, selectedResource,
      selectedLocation, selectedTimeSlots, enableResourceDropdown, enableLocationDropdown,
      style = {}
    } = this.props;

    const showPrice = setting && setting.hasOwnProperty('show_price') ? stringToBoolean(setting.show_price) : true;
    const dir = rtlRegions.includes(region) ? 'rtl' : '';
    const isNarrow = window.innerWidth < 270;

    return (
      <div className="appointment-block">
        {variants.map(({ title, price }, i) => {
          let header = `${productTitle}`

          if (!isDefaultTitle(title)) header += ` / ${title}`
          if (selectedResource && enableResourceDropdown) header = [header, selectedResource.name].join(' - ');
          if (selectedLocation && enableLocationDropdown) header = [header, selectedLocation.name].join(' - ');

          return (<div className="information_line bb-1 pb15" key={header + i}>
            {!isNarrow &&
              <div className="icon">
                <Icon iconName="calendar" style={{ ...style.title, marginRight: '8px' }} />
              </div>
            }
            <div className="inner">
              <span className="heading" style={{...style.title}}>{header}</span>
              {selectedTimeSlots?.length ?
                selectedTimeSlots.map((slot) => {
                  return <span dir={dir} className="date" key={dayjs(slot.start).format()} style={{fontSize: 'calc(100% - 2px)'}}>
                      {this.formatStatToEndTime(slot.start, slot.finish)}
                    </span>
                })
                :
                <span dir={dir} className="date" style={{fontSize: 'calc(100% - 2px)'}}>
                    {selectedTimeSlot
                    && this.formatStatToEndTime(selectedTimeSlot.start, selectedTimeSlot.finish)}
                  {selectedCourse
                  && this.formatStatToEndTime(selectedCourse.start_date, selectedCourse.finish_date)}
                  </span>
              }
            </div>
            {showPrice &&
              <div className="price">
                <span className="value" dangerouslySetInnerHTML={{ __html: interpolatePriceToTemplate(priceFormat(this.props.settings), price) }} />
              </div>
            }
          </div>)
        })}
      </div>
    );
  }
}

export default connect(({ settings }) => ({
  settings,
}))(VariantsBlock);

VariantsBlock.propTypes = {
  productTitle: PropTypes.string,
  variants: PropTypes.array.isRequired,
  selectedTimeSlot: PropTypes.object,
  selectedResource: PropTypes.object,
  locale: PropTypes.string,
  timeZone: PropTypes.string,
  timeFormat: PropTypes.string,
  priceSymbol: PropTypes.any,
  selectDifferentTime: PropTypes.func,
  enableResourceDropdown: PropTypes.bool,
  enableLocationDropdown: PropTypes.bool,
};
